import { AppContext } from "@/App.context";
import config from "@/config";
import { IdleContext } from "@/page-components/idle-resource/idle-context-file.part";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

/**
 * @typedef GetAllStatistics
 * @property {string} filter
 * @property {GetDataStatistics} data
 */

/**
 * @typedef GetDataStatistics
 * @property {string} id
 */

/**
 * @typedef GetIdleFilters
 * @property {string[]} accounts
 */

/**
 * @typedef GetAllStatisticsRes
 * @property {GetAllStatistics[]} statistics
 * @property {GetIdleFilters} filters
 */

/**
/**
 * @typedef GetAccountStatisticsReq
 * @property {'aws' | 'gcp' | 'azure'} service
 * @property {'account' | 'region' | 'rg' } selectedTittle
 */

export const getAccountStatistics = (token) => {
    /**
   * @param {GetAccountStatisticsReq} req
   * @param {AbortSignal=} signal
   * @returns {Promise<GetAllStatistics>}
   */
  return async ({ service,selectedTittle,filters,period,start_date,end_date, isHistory }, signal) => {
        const params = isHistory
    ? `?type=${selectedTittle}&start_date=${start_date}&end_date=${end_date}&period=${period}`
    : `?type=${selectedTittle}`;
    const owners = await fetch(
      `${config.apiHost}/v1/${service}/idle-resources/filter${params}`,
      {
        // method: "POST",
        // body: JSON.stringify({
        //   accounts: filters?.accounts || [],
        // }),
        method: service !== "azure" ? "GET" : "POST",
        body:
          service === "azure"
            ? JSON.stringify({
              subscriptions: filters?.accounts || [],
              })
            : undefined,
        signal,
        headers: {
          "Content-Type": "application/json",
          Authorization: token
        },
      }
    );
    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }
    return await owners.json();
  };
}

/**

 * @param {GetAccountStatisticsReq} req
 * @param {any[]=} deps
 */
export const useAccountStatistics = (req, deps = []) => {
  const appContext = useContext(AppContext);
   const idleContext = useContext(IdleContext);
   const isHistory = idleContext?.selectedOption === "History";
   const updatedReq = {
    ...req,
    isHistory,
  };
  const query = useQuery({
    queryKey: ["getAccountStatistics", updatedReq , ...deps],
    queryFn: ({ signal }) => getAccountStatistics(appContext.idToken)(updatedReq, signal),
    enabled: req.selectedTittle != null
  });
  return query;
};


